<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content" style="font-size: 12px">
    <div class="modal-header">
      <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="action('close')">
        <svg class="unity-icon unity-icon-times">
          <use xlink:href="#unity-icon-times"></use>
        </svg>
      </button>
      <h4 class="modal-title">{{ model.title }}</h4>
    </div>
    <ng-container *ngIf="ds.loadingCount > 0">
      <div class="ep-pageloadingindicator">
        <i class="fa fa-pulse fa-ep-loading fa-4x"></i>
      </div>
      <div class="ep-dialogprocessingoverlay"></div>
    </ng-container>
    <div class="modal-body">
      <!--Model {{ model | json }}-->
      <dataservice-error></dataservice-error>

      <ng-content></ng-content>
    </div>
    <div class="modal-footer">
      <button unity-button
        classes="primary"
        *ngIf="model.currentOptions.allowMultiSelect"
        type="button"
        (click)="action('select')"
      >
        Select
      </button>
      <button unity-button
        [class]="model.currentOptions.allowMultiSelect ? 'secondary' : 'primary'"
        *ngIf="model.currentOptions.allowClear"
        type="button"
        (click)="action('clear')"
      >
        Clear
      </button>
      <button unity-button
        [class]="!model.currentOptions.allowMultiSelect && !model.currentOptions.allowClear ? 'primary' : 'ghost'"
        type="button"
        (click)="action('cancel')"
        >Cancel</button>
    </div>
    <dataservice-debug *ngIf="app.Settings.Debug.ShowPageDataService"></dataservice-debug>
  </div>
</div>
